;(function () {
  'use strict';

  if (!customElements.get('customer-testimonials-component')) {
    class CustomerTestimonialsComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper.customer-testimonials__slider');
        this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
        this.swiper = null;
        this.prevButton = this.querySelector('.customer-testimonials__button-prev');
        this.nextButton = this.querySelector('.customer-testimonials__button-next');
      }

      connectedCallback() {
        if (this.slider && this.slides.length > 0) {
          this.initSwiper();
          window.addEventListener('resize', () => this.handleResize());
        }
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
        window.removeEventListener('resize', () => this.handleResize());
      }

      handleResize() {
        if (this.swiper) {
          this.swiper.update();
        }
      }

      initSwiper() {
        if (!this.slider) return;

        const slidesPerView = parseFloat(this.dataset.slidesPerView) || 3;
        const spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
        const slidesCount = this.slides.length;
        const isPDP = this.dataset.context === 'pdp';

        const actualSlidesPerView = Math.min(slidesPerView, slidesCount);
        const tabletSlidesPerView = isPDP ? Math.min(1, slidesCount) : Math.min(2, slidesCount);

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          loop: slidesCount > actualSlidesPerView,
          speed: 400,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          breakpoints: {
            750: {
              slidesPerView: tabletSlidesPerView,
              spaceBetween: spaceBetween,
            },
            1200: {
              slidesPerView: actualSlidesPerView,
              spaceBetween: spaceBetween,
            },
          },
        });

        // Update navigation button states
        if (this.swiper && slidesCount <= actualSlidesPerView) {
          if (this.prevButton) this.prevButton.style.opacity = '0.5';
          if (this.nextButton) this.nextButton.style.opacity = '0.5';
        }
      }
    }

    customElements.define('customer-testimonials-component', CustomerTestimonialsComponent);
  }
})();

